/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enter_Project_NameInputs */



/**
* | output |
* | --- |
* | "Please enter a project name:" |
*
* @param {Enter_Project_NameInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const enter_project_name = /** @type {((inputs?: Enter_Project_NameInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enter_Project_NameInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez entrer un nom de projet :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte geben Sie einen Projektnamen ein:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci un nome per il progetto:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, введите название проекта:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor, introduzca un nombre de proyecto:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请输入项目名称：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクト名を入力してください:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया प्रोजेक्ट का नाम दर्ज करें:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, insira o nome do projeto:")
	return /** @type {LocalizedString} */ ("Please enter a project name:")
});